import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {isPullRequestsEnabled} from '@github-ui/repo-app-flags'

// Pull Requests' routes can be registered under the unified `repo` app when the
// `repo_app_pull_requests` flag is on. The app's identity stays `pull-requests`,
// but in that case its query keys must use `repo` so they match the running
// app. The resolver is only evaluated when a query key is built (runtime), so it
// can safely read the flag.
export const pullRequestsAppBuilder = DataRouterApplicationBuilder.create('pull-requests', {
  queryKeyAppName: () => (isPullRequestsEnabled() ? 'repo' : 'pull-requests'),
})
